import { projectPatternAPI } from "./api";

export const getProjectPattern = async (projectGuid) => {
  try {
    const res = await projectPatternAPI.getProjectPattern(projectGuid);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getProjectByGuid = async (projectGuid, projectId = null) => {
  try {
    const res = await projectPatternAPI.getProjectByGuid(projectGuid, projectId);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const updateEntranceLink = async (project_entrance_id, usp_block_guid) => {
  try {
    const res = await projectPatternAPI.updateEntranceLink(project_entrance_id, usp_block_guid);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const updateFloorLink = async (floor_map_id, usp_level_guid) => {
  try {
    const res = await projectPatternAPI.updateFloorLink(floor_map_id, usp_level_guid);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const autoLinkEntranceSiblingsByName = async (project_entrance_id, target_usp_guid) => {
  try {
    const res = await projectPatternAPI.autoLinkEntranceSiblingsByName(project_entrance_id, target_usp_guid);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const autoLinkFloorSiblingsByName = async (floor_map_id, target_usp_guid) => {
  try {
    const res = await projectPatternAPI.autoLinkFloorSiblingsByName(floor_map_id, target_usp_guid);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const autoMapSbsByGuid = async (project_guid) => {
  try {
    const res = await projectPatternAPI.autoMapSbsByGuid(project_guid);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getProjectGroups = async () => {
  try {
    const res = await projectPatternAPI.getProjectGroups();
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const ingestProjectGroups = async () => {
  try {
    const res = await projectPatternAPI.ingestProjectGroups();
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const checkSendReadiness = async (projectGuid, projectId = null) => {
  try {
    const res = await projectPatternAPI.checkSendReadiness(projectGuid, projectId);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getGprPeriods = async (projectGuid, uspLevelGuids) => {
  try {
    const res = await projectPatternAPI.getGprPeriods(projectGuid, uspLevelGuids);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const ingestProjectPattern = async (project_guid, url) => {
  try {
    const res = await projectPatternAPI.ingestProjectPattern(project_guid, url);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getUspFloorMapSend = async (floor_map_id = null, project_id = null, project_entrance_id = null) => {
  try {
    const res = await projectPatternAPI.getUspFloorMapSend(floor_map_id, project_id, project_entrance_id);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getProjectUspJson = async (projectId) => {
  try {
    const res = await projectPatternAPI.getProjectUspJson(projectId);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getUspFactForOperfact = async (floor_map_id = null, project_entrance_id = null) => {
  try {
    const res = await projectPatternAPI.getUspFactForOperfact(floor_map_id, project_entrance_id);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getUspFactMaterialByFact = async (usp_fact_id) => {
  try {
    const res = await projectPatternAPI.getUspFactMaterialByFact(usp_fact_id);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getSectionMap = async () => {
  try {
    const res = await projectPatternAPI.getSectionMap();
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const modifySectionMap = async (body) => {
  try {
    const res = await projectPatternAPI.modifySectionMap(body);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const deleteSectionMap = async (id) => {
  try {
    const res = await projectPatternAPI.deleteSectionMap(id);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getSectionMapProjectTypes = async () => {
  try {
    const res = await projectPatternAPI.getSectionMapProjectTypes();
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const savePpmPeriod = async (body) => {
  try {
    const res = await projectPatternAPI.savePpmPeriod(body);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const materialSearch = async (search = null) => {
  try {
    const res = await projectPatternAPI.materialSearch(search);
    return res?.data ?? res ?? [];
  } catch (e) {
    return [];
  }
};

export const getWorkDetail = async (floorMapId, workSetId, workSetCheckGroupId) => {
  try {
    const res = await projectPatternAPI.getWorkDetail(floorMapId, workSetId, workSetCheckGroupId);
    return res?.data ?? res;
  } catch (e) {
    return null;
  }
};

export const getWorkGuidByProject = async (projectGuid, blockGuid, etazhGuid, projectId) => {
  try {
    const res = await projectPatternAPI.getWorkGuidByProject(projectGuid, blockGuid, etazhGuid, projectId);
    return res?.data;
  } catch (e) {
    return null;
  }
};

export const checkWorkGuidsBatch = async (projectGuid) => {
  try {
    const res = await projectPatternAPI.checkWorkGuidsBatch(projectGuid);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getWorkSetsForFloor = async (floorMapId) => {
  try {
    const res = await projectPatternAPI.getWorkSetsForFloor(floorMapId);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getWorkSetsForMatrix = async (floorMapId) => {
  try {
    const res = await projectPatternAPI.getWorkSetsForMatrix(floorMapId);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const uspFactSave = async (body) => {
  try {
    const res = await projectPatternAPI.uspFactSave(body);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactCorrectionSave = async (body) => {
  try {
    const res = await projectPatternAPI.uspFactCorrectionSave(body);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactCorrectionRead = async (body) => {
  try {
    const res = await projectPatternAPI.uspFactCorrectionRead(body);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactDelete = async (body) => {
  try {
    const res = await projectPatternAPI.uspFactDelete(body);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const projectPatternReadFiltered = async (projectGuid, projectTypeName, contractorId) => {
  try {
    const res = await projectPatternAPI.projectPatternReadFiltered(projectGuid, projectTypeName, contractorId);
    return res?.data ?? res ?? [];
  } catch (e) {
    throw e;
  }
};

export const getProjectTypes = async (projectGuid) => {
  try {
    const res = await projectPatternAPI.getProjectTypes(projectGuid);
    return res?.data ?? res ?? [];
  } catch (e) {
    return [];
  }
};

export const getContractors = async (projectGuid) => {
  try {
    const res = await projectPatternAPI.getContractors(projectGuid);
    return res?.data ?? res ?? [];
  } catch (e) {
    return [];
  }
};

export const getContractorsSMR = async (projectGuid, projectTypeId = null) => {
  try {
    const res = await projectPatternAPI.getContractorsSMR(projectGuid, projectTypeId);
    return res?.data ?? res ?? [];
  } catch (e) {
    return [];
  }
};

export const uspWorkComplete = async (body) => {
  const res = await projectPatternAPI.uspWorkComplete(body);
  return res?.data ?? res;
};

export const uspFactFillWorkGuid = async (projectGuid) => {
  const res = await projectPatternAPI.uspFactFillWorkGuid({ project_guid: projectGuid });
  return res?.data ?? res;
};

export const getProjectTypesByContractor = async (projectGuid, contractorId) => {
  try {
    const res = await projectPatternAPI.getProjectTypesByContractor(projectGuid, contractorId);
    return res?.data ?? res ?? [];
  } catch (e) {
    return [];
  }
};

export const getContractorsByType = async (projectGuid, projectTypeId) => {
  try {
    const res = await projectPatternAPI.getContractorsByType(projectGuid, projectTypeId);
    return res?.data ?? res ?? [];
  } catch (e) {
    return [];
  }
};

export const uspFactRead = async (params) => {
  try {
    const res = await projectPatternAPI.uspFactRead(params);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactSummaryRead = async (params) => {
  try {
    const res = await projectPatternAPI.uspFactSummaryRead(params);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactHistoryRead = async (params) => {
  try {
    const res = await projectPatternAPI.uspFactHistoryRead(params);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactSend = async (body) => {
  try {
    const res = await projectPatternAPI.uspFactSend(body);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactBuildJsonSelected = async (body) => {
  try {
    const res = await projectPatternAPI.uspFactBuildJsonSelected(body);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactBuildCorrectionJson = async (body) => {
  try {
    const res = await projectPatternAPI.uspFactBuildCorrectionJson(body);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactBuildStornoJson = async (body) => {
  try {
    const res = await projectPatternAPI.uspFactBuildStornoJson(body);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactBuildStornoJsonPartial = async (body) => {
  try {
    const res = await projectPatternAPI.uspFactBuildStornoJsonPartial(body);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactSendAction = async (body) => {
  try {
    const res = await projectPatternAPI.uspFactSendAction(body);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactSendActionPartial = async (body) => {
  try {
    const res = await projectPatternAPI.uspFactSendActionPartial(body);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspFactSendSelected = async (body) => {
  try {
    const res = await projectPatternAPI.uspFactSendSelected(body);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspSbsDataRefresh = async (projectGuid) => {
  try {
    const res = await projectPatternAPI.uspSbsDataRefresh(projectGuid);
    return res?.data ?? res;
  } catch (e) {
    throw e;
  }
};

export const uspReportRead = async (projectGuid) => {
  try {
    const res = await projectPatternAPI.uspReportRead(projectGuid);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const uspReportFactsRead = async (projectGuid, workGuid) => {
  try {
    const res = await projectPatternAPI.uspReportFactsRead(projectGuid, workGuid);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const uspReportWorkDetailRead = async (projectGuid, floorMapId, workSetId, workSetCheckGroupId) => {
  try {
    const res = await projectPatternAPI.uspReportWorkDetailRead(projectGuid, floorMapId, workSetId, workSetCheckGroupId);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const uspReportUspDetailRead = async (projectGuid, uspWorkGuid) => {
  try {
    const res = await projectPatternAPI.uspReportUspDetailRead(projectGuid, uspWorkGuid);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const uspDiscrepancyRead = async (projectGuid) => {
  try {
    const res = await projectPatternAPI.uspDiscrepancyRead({ project_guid: projectGuid });
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const uspStornoListRead = async (projectGuid) => {
  try {
    const res = await projectPatternAPI.uspStornoListRead({ project_guid: projectGuid });
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const uspDiscrepancyDetailRead = async (projectGuid, workGuid) => {
  try {
    const res = await projectPatternAPI.uspDiscrepancyDetailRead({
      project_guid: projectGuid,
      work_guid: workGuid,
    });
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const uspFactAlignToSmeta = async (projectGuid, combos, options = {}) => {
  try {
    const { force = false, dryRun = false } = options;
    const res = await projectPatternAPI.uspFactAlignToSmeta({
      project_guid: projectGuid,
      combos,
      force,
      dry_run: dryRun,
    });
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getSmetaSummary = async (projectGuid, projectId = null) => {
  try {
    const res = await projectPatternAPI.getSmetaSummary(projectGuid, projectId);
    return res?.data ?? res ?? [];
  } catch (e) {
    throw e;
  }
};

export const smetaChangeLogUnsignedRead = async (projectGuid) => {
  try {
    const res = await projectPatternAPI.smetaChangeLogUnsignedRead({
      project_guid: projectGuid,
    });
    return res?.data ?? res ?? [];
  } catch (e) {
    return [];
  }
};

export const cronLogJsonRead = async (logId, logType) => {
  try {
    const res = await projectPatternAPI.cronLogJsonRead({ log_id: logId, log_type: logType });
    return res?.data ?? res ?? {};
  } catch (e) {
    throw e;
  }
};

export const cronHistoryRead = async (projectGuid, logType) => {
  try {
    const res = await projectPatternAPI.cronHistoryRead({ project_guid: projectGuid, log_type: logType });
    return res?.data ?? res ?? [];
  } catch (e) {
    return [];
  }
};

export const cronStatusRead = async (projectGuid) => {
  try {
    const res = await projectPatternAPI.cronStatusRead({ project_guid: projectGuid });
    return res?.data ?? res ?? {};
  } catch (e) {
    return {};
  }
};

export const cronUpdateSmeta = async () => {
  try {
    const res = await projectPatternAPI.cronUpdateSmeta();
    return res?.data ?? res ?? [];
  } catch (e) {
    throw e;
  }
};

export const cronCreateContracts = async () => {
  try {
    const res = await projectPatternAPI.cronCreateContracts();
    return res?.data ?? res ?? [];
  } catch (e) {
    throw e;
  }
};

export const uspEstimateSendSelected = async (body) => {
  try {
    const res = await projectPatternAPI.uspEstimateSendSelected(body);
    return res?.data ?? res ?? {};
  } catch (e) {
    throw e;
  }
};

export const uspEstimateBuildJson = async (body) => {
  try {
    const res = await projectPatternAPI.uspEstimateBuildJson(body);
    return res?.data ?? res ?? {};
  } catch (e) {
    throw e;
  }
};
